import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

const ToxicologySeamlessDrugTesting = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem right-padding6rem py-md-5 py-4'>
           <div className='pt-3 pt-md-0'>
                <text className='fs-ss-30-2 text-ss-primary fw-700 text-montserrat lh-1-2'>
                    Streamline Drug Testing Process With Seamless Ease 
                </text>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
          </div> 

          <div className='py-3'>
                <text className='fs-ss-16 text-montserrat text-ss-black fw-600'>
                    Safeguard your health, workplace, and environment with our trusted toxicology screening services. United Lab Care is here to provide accurate and actionable results, empowering you to make informed decisions and ensure the well-being of individuals and communities. 
                </text>
          </div> 

          <div className='py-3'>
                <text className='fs-ss-16 text-montserrat text-ss-black fw-600'>
                    Experience the seamless expertise of United Lab Care as our skilled professionals deliver unmatched reliability in drug testing services. With cutting-edge technology and advanced methods, we ensure every result is accurate, trustworthy, and of the highest standard. 
                </text>
          </div> 

          <div className='py-3'>
                <text className='fs-ss-16 text-montserrat text-ss-black fw-600'>
                    Whether you’re a pioneering drug developer, a regulatory agency striving for excellence, or an environmental consultant dedicated to preserving our planet, our comprehensive workplace drug testing services are tailored to your needs. Embrace the confidence of uncompromising quality and contact us today to access our unrivaled toxicology and drug testing services in the vibrant city of Chicago.
                </text>
          </div> 

          <div className='flex-center py-4'>
                <Button className='btn-ss-secondary rounded30 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                <Link to='/toxicology-test-appointment' className='text-montserrat text-white fw-600 fs-ss-18' style={{ padding:'12px 14px', textDecoration:'none'}}>
                    Schedule Your Test
                </Link>
                </Button>
          </div>  
        </div>
    </div>
  )
}

export default ToxicologySeamlessDrugTesting